import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Iconify, Logo } from "..";
import { useTranslation } from "../../../fe-ui/hooks/use-translation";
import { FormEvent, useCallback } from "react";
import { ContentApiClient } from "../../../api/content-client";
import { useMutation } from "react-query";
import { IncomingRequestRequest } from "../../../api/content-client/service";
import { RecaptchaController, useRecaptchaCallback } from "../../../controllers/RecaptchaController";
import { useRouter } from "next/router";
import { emitYMAnalytics } from "../YMInitializer/YMInitializer";

export const LandingFooterDefault = () => {
  const theme = useTheme();
  const t = useTranslation();
  const waitForRecaptchaToken = useRecaptchaCallback();

  const {
    mutate: submit,
    isLoading,
    isSuccess,
    // isError,
  } = useMutation(async (params: IncomingRequestRequest) => {
    const recaptchaToken = await waitForRecaptchaToken();

    ContentApiClient.incomingRequests.postIncomingRequests({
      token: recaptchaToken,
      data: { ...params },
    } as unknown as IncomingRequestRequest);
  });

  const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    submit(Object.fromEntries(formData) as unknown as IncomingRequestRequest);
    emitYMAnalytics("SUBMIT_FORM_FOOTER_DEFAULT_REQUEST");
  }, []);

  const { pathname } = useRouter();

  return (
    <>
      <Box
        id="footer-contact-form"
        sx={{
          backgroundColor: theme.palette.grey[100],
          py: 8,
        }}
      >
        <Container>
          <Grid container>
            <Grid item sm={6}>
              <Stack spacing={1} direction={"column"}>
                <Box sx={{ width: "auto" }}>
                  <Logo isDark />
                </Box>
                {/* <Typography variant="bodyLg" color="text.secondary">
                  {t("footer_label_callus")}
                </Typography>
                <Box sx={{ width: "auto" }}>
                  <Typography variant="bodyXl" color="text.secondary">
                    {"+994 (55) 8012090"}
                  </Typography>
                </Box> */}
                <Typography variant="bodyLg" color="text.secondary">
                  {t("footer_label_writeus")}
                </Typography>
                <Box sx={{ width: "auto" }}>
                  <Link color={"secondary.light"} href="mailto:sales@seaya.az" target="_blank">
                    <Typography variant="bodyXl">{"sales@seaya.az"}</Typography>
                  </Link>
                </Box>
                <Box sx={{ width: "auto", mb: { xs: 2 } }}>
                  <Link color={"secondary.light"} href="https://wa.me/994103006090" target="_blank">
                    <Iconify icon="ic:baseline-whatsapp" width={22} sx={{ marginBottom: "-2px" }} />
                    <Typography variant="bodyXl">{"WhatsApp"}</Typography>
                  </Link>
                </Box>
              </Stack>
            </Grid>
            <Grid item sm={6}>
              <Paper elevation={8} sx={{ borderRadius: 2, p: 2.5, mt: { xs: 2 } }}>
                <Typography variant="h4" mb={3}>
                  {t("contact_form_default_title")}
                </Typography>

                {isSuccess && (
                  <>
                    <Alert severity={"success"}>
                      <AlertTitle>{t("contact_form_default_success_title")}</AlertTitle>
                      <Typography>{t("contact_form_default_success_text")}</Typography>
                    </Alert>
                  </>
                )}

                {!isSuccess && (
                  <>
                    <form onSubmit={handleSubmit}>
                      <RecaptchaController Wrapper={({ children }) => <>{children}</>}>
                        <input type="hidden" name="status" value="new" />
                        <input type="hidden" name="url" value={pathname} />
                        <Stack direction={"column"} spacing={2} mb={1}>
                          <TextField
                            required
                            disabled={isLoading}
                            variant="filled"
                            name="email"
                            size="small"
                            label={t("form_email_placeholder")}
                          />
                          <TextField
                            required
                            disabled={isLoading}
                            variant="filled"
                            name="name"
                            size="small"
                            label={t("form_name_placeholder")}
                          />
                          <TextField
                            disabled={isLoading}
                            variant="filled"
                            name="phone"
                            size="small"
                            label={t("form_phone_placeholder")}
                          />
                          <Button disabled={isLoading} type="submit" size="large" color="primary" variant="contained">
                            {isLoading ? "..." : t("contact_form_default_button")}
                          </Button>
                        </Stack>
                      </RecaptchaController>
                    </form>
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
